import useRequest from "./useRequest";
import { useState } from "react";

const useCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [companyDetail, setCompanyDetail] = useState(null);
  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
    detail: false,
  });

  const { request } = useRequest();

  async function getCompanies(params = {}) {
    try {
      setLoading((prev) => ({ ...prev, get: true }));
      const data = await request(
        "GET",
        "companies/",
        (data) => {
          setCompanies(data);
        },
        (error) => {
          throw error;
        },
        {},
        params
      );
      return data;
    } catch (error) {
      throw error;
    } finally {
      setLoading((prev) => ({ ...prev, get: false }));
    }
  }

  async function getCompanyDetail(companyId) {
    try {
      setLoading((prev) => ({ ...prev, detail: true }));
      const data = await request(
        "GET",
        `companies/${companyId}/`,
        (data) => {
          setCompanyDetail(data);
        },
        (error) => {
          throw error;
        }
      );
      return data;
    } catch (error) {
      throw error;
    } finally {
      setLoading((prev) => ({ ...prev, detail: false }));
    }
  }

  return { 
    getCompanies, 
    getCompanyDetail, 
    companies, 
    companyDetail, 
    setCompanies, 
    setCompanyDetail, 
    loading 
  };
};

export default useCompanies;
